const Header = {
    init: function () {
        this.menuToggler();
        this.anchor();
    },

    menuToggler: function () {
        const menuButton = document.querySelector('.header .nav-burger');
        const menu = document.querySelector('.header .nav-main');

        menuButton?.addEventListener('click', () => {
            menu.classList.toggle('is-open');

            if ( menu.classList.contains('is-open') ) {
                menuButton.innerHTML = menuButton.dataset.toggleOpen;
            } else {
                menuButton.innerHTML = menuButton.dataset.toggleClosed;
            }
        });
    },

    anchor: function () {
        const anchorLinks = document.querySelectorAll('header a[href*="#"], main a[href*="#"], footer a[href*="#"]');

        anchorLinks.forEach(link => {
            link?.addEventListener('click', (e) => {
                const href = link.getAttribute('href');
                if (!href.includes('#')) return;
                const id = href.substring(href.indexOf('#') + 1);
                const target = document.getElementById(id) || document.querySelector(`a[name="${id}"]`) || document.querySelector(href);
                if (!target) return;
                e.preventDefault();
                this.scrollTo(target);
            });
        });
    },

    scrollTo: function (target) {
        const menuButton = document.querySelector('header.header .nav-burger');
        const menu = document.querySelector('header.header .nav-main');

        const header = document.querySelector('header.header');
        const headerHeight = header ? (header.offsetHeight - 5 ) : 85;
        const targetPosition = target.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = Math.max(0, targetPosition - headerHeight);

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
        });

        menu?.classList.remove('is-open');
        if (menuButton) menuButton.innerHTML = menuButton.dataset.toggleClosed;
    },
}

export default Header;